const config: any = {}

switch(process.env.NODE_ENV) {
    case 'development':
        config.apiUrl = 'http://socanapp.com:4000'
        break
    case 'sango-test':
        config.apiUrl = 'https://sango-testing.in'
        break
    case 'socan-test':
        config.apiUrl = 'https://socan-testing.in'
        break
    case 'prod':
        config.apiUrl = 'https://socan-prod.in'
        break
    case 'prod-t1':
        config.apiUrl = 'https://socan-prod-t1.in'
        break
    case 'local-jbox':
        config.apiUrl = `http://${window.location.hostname}:4000`
    default:
        console.log('Unknown NODE_ENV!')
        break
}

export default config
